export class HelpFormDTO {
  phoneNumber: string;
  issueDescription: string;

  constructor() {
    this.phoneNumber = '';
    this.issueDescription = '';
  }
}
